import React, { useEffect, useState } from "react";
import { getCitas } from "../../services/citaService";
import { getMonday, addDays } from "../../utils/fechas";

const HORA_INICIO = 9;
const HORA_FIN = 22;
const PX_HORA = 60;

const HORAS = Array.from(
  { length: HORA_FIN - HORA_INICIO },
  (_, i) => HORA_INICIO + i
);

export default function VistaSemanal({
  fecha,
  clinica,
  profesional,
  refrescar,
  onSelectCita,
  onNuevaCita
}) {
  const [citas, setCitas] = useState([]);

  const inicioSemana = getMonday(fecha);
  const dias = Array.from({ length: 5 }, (_, i) => addDays(inicioSemana, i));

  function obtenerColorCita(cita) {

    if (cita.profesional === "LIS") {

      if (cita.clinica === "VEN") {
        return "#86efac";
      }

      if (cita.clinica === "ELIPA") {
        return "#c084fc";
      }
    }

    return {
      ELIPA: "#59b3f8a4",
      VEN: "#fce3aeff"
    }[cita.clinica] || "#f5faff";
  }

  const COLOR_TRATAMIENTO= {
    MARIA: "#eeff00",
    LUCIA: "#1eff00",
    LIS_ONDONTO: "#f700ff",
    LUIS: "#ff0000",
    PAOLA: "#ff9100" 
  };

  function agruparSolapadas(citas) {
    const grupos = [];

    citas.forEach(cita => {
      const inicio = new Date(cita.fechaInicio);
      const fin = new Date(inicio.getTime() + cita.duracionMin * 60000);

      let grupo = grupos.find(g =>
        g.some(c => {
          const i = new Date(c.fechaInicio);
          const f = new Date(i.getTime() + c.duracionMin * 60000);
          return inicio < f && fin > i;
        })
      );

      if (!grupo) {
        grupo = [];
        grupos.push(grupo);
      }

      grupo.push(cita);
    });

    return grupos;
  }

  function pintarCitasDia(citas, fechaDia, onSelect) {
    const delDia = citas.filter(c => {
      const d = new Date(c.fechaInicio);
      return d.toDateString() === fechaDia.toDateString();
    });

    const grupos = agruparSolapadas(delDia);

    return grupos.flatMap(grupo =>
      grupo.map((cita, idx) => {
        const inicio = new Date(cita.fechaInicio);

        const minutos =
          (inicio.getHours() - HORA_INICIO) * 60 +
          inicio.getMinutes();

        const top = (minutos * PX_HORA) / 60;

        const heightReal = (cita.duracionMin * PX_HORA) / 60;
        const height = Math.max(heightReal, 26);

        const width = 100 / grupo.length;

        const mostrarPaciente = height >= 18;
        const mostrarTratamiento = height >= 26;

        return (
          <div
            key={cita.id}
            className="cita cita-semanal"
            data-tooltip={`${cita.paciente}\n${cita.tratamiento}`}
            style={{
              top,
              height,
              left: `calc(${idx * width}% + 3px)`,
              width: `calc(${width}% - 6px)`,
              borderLeft: `4px solid ${cita.color || "#1890ff"}`,
              background: obtenerColorCita(cita)
            }}
            onClick={() => onSelect(cita)}
          >
          <div className="cita-contenido">
            {mostrarPaciente && <strong>{cita.paciente}</strong>}
            {mostrarTratamiento && <div>{cita.tratamiento}</div>}
          </div>
          </div>
        );
      })
    );
  }

  useEffect(() => {
    getCitas({
      clinica,
      profesional,
      from: inicioSemana.toISOString().slice(0, 10),
      to: addDays(inicioSemana, 4).toISOString().slice(0, 10)
    }).then(setCitas);
  }, [fecha, clinica, profesional, refrescar]);

  const ahora = new Date();
  const hoy = new Date();

  const minutosDesdeInicio =
    (ahora.getHours() - HORA_INICIO) * 60 +
    ahora.getMinutes();

  const topHoraActual = (minutosDesdeInicio * PX_HORA) / 60;

  const citasFiltradas = citas.filter(c => {
    const coincideClinica =
      clinica === "ALL" || c.clinica === clinica;

    const coincideProfesional =
      profesional === "ALL" || c.profesional === profesional;

    return coincideClinica && coincideProfesional;
  });

  return (
    <div className="agenda">
      <div className="agenda-grid">

        <div className="agenda-header">
          <div className="hora-col-header"></div>

          {dias.map(d => (
            <div
              key={d}
              className={`dia-header ${
                d.toDateString() === hoy.toDateString() ? "hoy" : ""
              }`}
            >
              {d.toLocaleDateString("es-ES", {
                weekday: "long",
                day: "numeric"
              })}
            </div>
          ))}
        </div>

        <div className="agenda-body">

          <div className="hora-col">
            {HORAS.map(h => (
              <div key={h} className="hora-label">
                {h}:00
              </div>
            ))}
          </div>

          <div className="dias-grid">
            {dias.map((diaFecha, col) => {
              const esHoyColumna =
                diaFecha.toDateString() === hoy.toDateString();

              return (
                <div key={col} className="dia-col">

                  {HORAS.map(h => (
                    <div
                      key={h}
                      className="celda-hora"
                      onClick={() => onNuevaCita(diaFecha, h)}
                    />
                  ))}

                  {esHoyColumna && (
                    <div
                      className="linea-hora-actual"
                      style={{ top: topHoraActual }}
                    />
                  )}

                  {pintarCitasDia(
                    citasFiltradas,
                    diaFecha,
                    onSelectCita
                  )}

                </div>
              );
            })}
          </div>

        </div>
      </div>
    </div>
  );
}